// ---- Action types ----
export const CHANGE_ACTIVE_ITEM_HOME = "CH_HOME";
export const CHANGE_ACTIVE_ITEM_LIVELIST = "CH_LIVELIST";
export const CHANGE_ACTIVE_ITEM_LOG = "CH_LOG";
export const CHANGE_ACTIVE_ITEM_CONFIG = "CH_CONFIG";
export const CHANGE_ACTIVE_ITEM_INVENTORY = "CH_INVENTORY";
export const CHANGE_ACTIVE_ITEM_PORTS = "CH_PORTS";
export const CHANGE_ACTIVE_ITEM_MEDIA = "CH_MEDIA";
export const CHANGE_ACTIVE_ITEM_INTERFACE = "CH_INTERFACE";
export const CHANGE_ACTIVE_ITEM_NETWORK = "CH_NETWORK";
export const CHANGE_ACTIVE_PING_GRAPH = "CH_PING_GRAPH";
export const CHANGE_ACTIVE_TOPOLOGY = "CH_TOPOLOGY";
export const SOLVE_PROBLEM = "SOLVE_PROBLEM";
export const CHANGE_ACTIVE_ITEM_GRAPHIC_TOPOLOGY = "CH_GRAPHIC_TOPOLOGY";